import authService from '../components/api-authorization/AuthorizeService'
import { LoyaltyOptions } from '../models/loyaltyOptions';

export default class EventController {
    async GetLoyaltyOptions() : Promise<LoyaltyOptions | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('settings/GetLoyaltyOptions', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }
}